import { DropTarget } from 'react-dnd'
import CCSGovEnrolments from './ccs-gov-enrolments'

export default DropTarget(
  'ccs_enrolment',
  {
    drop: (props, monitor, dropZoneComponent) =>
      monitor.getItem() ? dropZoneComponent.handleDrop(monitor) : null
  },
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  })
)(CCSGovEnrolments)



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/container.js